import Service from "../../../Services/index";
const ExportProduct = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        REPLACE_DATA: (state, res) => {
            state.replace_data = res;
        },

    },
    actions: {
        get({ commit },page=1) {
            return Service.ImportProduct.getImportProducts(page);
        },
        show({ commit }, id) {
            return Service.ImportProduct.showImportProducts(id).then(
                response => {
                    commit("REPLACE_DATA", response);
                }
            );
        },
        create({ commit }, data) {
            return Service.ImportProduct.createImportProducts(data);
        },
        update({ commit }, { id, data }) {
            return Service.ImportProduct.updateImportProducts(id, data);
        },
        delete({ commit }, id) {
            return Service.ImportProduct.deleteImportProducts(id);
        },
        search({ commit }, { page="",code, date_start,date_end,type_id }) {
            return Service.ImportProduct.searchImportProducts(page,code, date_start,date_end,type_id);
        },
    }
};
export default ExportProduct;
